/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Service_Add_GbpInputs */

const vi_carrier_service_add_gbp = /** @type {(inputs: Carrier_Service_Add_GbpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo phát`)
};

/**

* @param {Carrier_Service_Add_GbpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_service_add_gbp = /** @type {((inputs?: Carrier_Service_Add_GbpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Service_Add_GbpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_service_add_gbp(inputs)
});